import { graphql } from "gql";

const INTERNAL_ADMIN_EDIT_USER_ATTRIBUTE_CATEGORY_MUTATION = graphql(`
  mutation InternalAdminEditUserAttributeCategory(
    $organizationId: ID!
    $id: ID!
    $input: AdminEditUserAttributeCategoryInput!
  ) {
    internalAdminEditUserAttributeCategory(
      organizationId: $organizationId
      id: $id
      input: $input
    ) {
      ...InternalAdminUserAttributeCategory
    }
  }
`);

export default INTERNAL_ADMIN_EDIT_USER_ATTRIBUTE_CATEGORY_MUTATION;
